module.exports = __webpack_public_path__ + "img/ic_round-logout.1feffa2e.png";